export default{
   getJsonObj(icon){
      if(icon){
         return JSON.parse(icon);
      }else{
         return null;
      }
   },
   getJsonStr(icon){
      if(icon){
         return JSON.stringify(icon);
      }else{
         return "";
      }
   },
   getJsonUrl(icon){
      if(icon){
         return JSON.parse(icon).url;
      }else{
         return "";
      }
   },
   getSelectVal(state){
     //0,"",null,undefined会认为false
      if(state){
        return state;
      }else{
        if(state!==0){
            return -1;      
        }else{
           return 0;
        }
      }
   },
   //笛卡儿积组合
   descartes(list) {
  //parent上一级索引;count指针计数
     var point = {};
     var result = [];
     var curNode=null;
     //根据参数列生成指针对象
     for (var index in list) {
       if (typeof list[index] == 'object') {
         point[index] = {
           'parent': curNode,//记录兄节点的位置
           'child': 0      //记录子节点的位置
         }
         curNode = index;
       }
     }
     //单维度数据结构直接返回
     if (curNode == null) {
       return list;
     }
     //动态生成笛卡尔积
     while (true) {
       /*遍历每个节点的指针所指向的子节点数据*/
       let temp={};
       for (var index in list) {
         let child = point[index]['child'];
         let t={};
         t[index]=list[index][child];
         Object.assign(temp,t);
         curNode=index;
       }
       //压入结果数组
       result.push(temp);
       temp = {};

       /*1.当当前节点的子节点未访问结束，则移动到下一个子节点位置
       2.当当前节点的子节点访问结束，则把当前指针移到上一个节点，从1开始循环
       3.每个节点的子节点位置改变，则进行一次数据遍历；每移动当前节点的指针，则对下一节点的子节点的位置进行改变*/
       while (true) {
         if (point[curNode]['child'] + 1 >= list[curNode].length) {
           //把当前节点的指针移动到上一个节点
           point[curNode]['child'] = 0;
           let pIndex = point[curNode]['parent'];
           if (pIndex == null) {
             return result;
           }
           //赋值parent进行再次检查
           curNode = pIndex;
         } else {
           //移动当前节点的子节点的位置
           point[curNode]['child']++;
           break;
         }
       }
     }

   }



}



// WEBPACK FOOTER //
// ./src/utils/transform/business.js